:host {
    display: flex;
    box-sizing: border-box;
    transition: all 300ms ease-in-out;

    @media (prefers-reduced-motion: reduce) {
        transition: none !important;
    }

    * {
        box-sizing: border-box;

        @media (prefers-reduced-motion: reduce) {
            transition: none !important;
        }
    }
}

ux-iws-link-wrapper {
    width: 100%;
    display: flex;
}

.tile-container {
    position: relative;
    width: 100%;
    min-height: 400px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    @media (max-width: 799px) {
        min-height: 300px;
    }
}

.gradient-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
        279deg,
        rgba(0, 80, 116, 0) 7.97%,
        #005074 99.51%
    );
    transition: opacity 300ms ease-in-out;
    pointer-events: none;
}

// Hover effect on the link wrapper fades out the gradient
:host(:hover) .gradient-overlay {
    opacity: 0;
}

.content {
    position: relative;
    z-index: 1;
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    @media (max-width: 799px) {
        padding: 20px;
    }
}

.text-content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.title-container {
    ::slotted([slot="title"]) {
        @include font(light);
        font-size: 28px;
        line-height: 1.15;
        color: #fff;
        margin: 0;

        @media (max-width: 1024px) {
            font-size: 20px;
        }

        @media (max-width: 799px) {
            font-size: 18px;
        }

        @media (max-width: 400px) {
            font-size: 16px;
        }
    }
}

.copy-container {
    ::slotted([slot="copy"]) {
        @include font(light);
        font-size: 20px;
        line-height: 1.2;
        color: #fff;
        margin: 0;
        max-width: 450px;

        @media (max-width: 1024px) {
            font-size: 18px;
        }

        @media (max-width: 799px) {
            font-size: 16px;
        }

        @media (max-width: 400px) {
            font-size: 14px;
        }
    }
}

.link-container {
    margin-top: auto;
    padding-top: 20px;
}

.contact-link {
    @include font(bold);
    display: inline-flex;
    align-items: center;
    gap: 10px;
    color: #fff;
    text-decoration: none;
    font-size: 13px;
    line-height: 16px;
    text-transform: uppercase;
    border: 1px solid #fff;
    padding: 13px 30px;
    height: 44px;
    background-color: transparent;
    transition: all 300ms ease-in-out;
    cursor: pointer;

    ux-icon {
        font-size: 14px;
    }

    // Hover effect when the wrapper is hovered
    :host(:hover) & {
        background-color: #fff;
        color: #000;
    }

    @media (max-width: 400px) {
        width: 100%;
        justify-content: space-between;

        ux-icon {
            margin-left: auto;
        }
    }
}

// Wide tile styles
:host(.is-wide) {
    .tile-container {
        min-height: 500px;
    }

    .copy-container {
        ::slotted([slot="copy"]) {
            max-width: 660px;
        }
    }

    // Wide tile mobile override
    @media (max-width: 799px) {
        .tile-container {
            min-height: 400px;
        }
    }
}
